// How a task or order is named outside its own row: the { kind, id, schema }
// the backend takes, the key its activity summary comes back under, and the
// #task-… / #order-… link a 📋 chip in a chat message carries. Pure, so the
// sanitizer, the composer and the thread share one definition.

const UUID = "[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}";
export const WORK_ITEM_HREF_RE = new RegExp(`^#(?:task-(${UUID})|order-([A-Za-z0-9_]+)-(${UUID}))$`, "i");
const LINK_TITLE_MAX = 80;

// What the backend wants: tasks carry no schema; an order's defaults to public.
export function refOf({ kind, id, schema }) {
  return kind === "order" ? { kind, id, schema: schema || "public" } : { kind, id };
}

export function summaryKey({ kind, id, schema }) {
  return kind === "order" ? `order:${schema || "public"}:${id}` : `task:${id}`;
}

export function workItemHref({ kind, id, schema }) {
  return kind === "order" ? `#order-${schema || "public"}-${id}` : `#task-${id}`;
}

// The ref a chat link points at, or null for any other link.
export function parseWorkItemHref(href) {
  const m = WORK_ITEM_HREF_RE.exec(String(href || "").trim());
  if (!m) return null;
  return m[1]
    ? { kind: "task", id: m[1].toLowerCase(), schema: null }
    : { kind: "order", id: m[3].toLowerCase(), schema: m[2] };
}

// "📋 Call pharmacy", or "📋 CBC · Jane Doe" for an order.
export function workItemLinkText(item) {
  const raw = String(item.title || "").trim() || (item.kind === "order" ? "Order" : "Task");
  const title = raw.length > LINK_TITLE_MAX ? `${raw.slice(0, LINK_TITLE_MAX - 1)}…` : raw;
  const patient = item.kind === "order" && item.patientName ? ` · ${item.patientName}` : "";
  return `📋 ${title}${patient}`;
}
